<script lang="ts">
    export let label: string;
    export let count: string;
</script>

<div class="import-analyze-row-container">
    <div>{label}:</div>
    <div class="bold dont-break">{count}</div>
    <!--    <div>{values}</div>-->
</div>

<style>
    .import-analyze-row-container {
        display: flex;
        flex-direction: row;
        column-gap: 10px;
    }
</style>
